module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nQy0RX/tc-custom/9781473852341.jpg?1702846858929",
      "alt": "This image is the cover for the book Eagles in the Dust"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Eagles in the Dust\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In AD376 large groups of Goths, seeking refuge from the Huns, sought admittance to the Eastern Roman Empire. Emperor Valens took the strategic decision to grant them entry, hoping to utilize them as a source of manpower for his campaigns against Persia. The Goths had been providing good warriors to Roman armies for decades. However, mistreatment of the refugees by Roman officials led them to take up arms against their hosts. The resultant battle near Adrianopolis in AD378, in which Valens lost his life, is regarded as one of the most significant defeats ever suffered by Roman arms. The Roman historian Ammianus Marcellinus called it the worst massacre since Cannae, nearly six hundred years previously. Modern historians have accorded it great significance both at a tactical level, due to the success of Gothic cavalry over the vaunted Roman infantry, and in strategic terms, often citing it as the beginning of the end for the Empire. Adrian Coombs-Hoar untangles the debate that still surrounds many aspects such claims with an insightful account that draws on the latest research.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Adrian Coombs-Hoar\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0